import type { MessagingTemplate } from "src-next/modules/crm-clinical/messaging/types";

/**
 * Tenta associar `templateCode` do Basic FluxZap a um `MessagingTemplate` da organização.
 * Estratégia conservadora: id exato, sufixo após `_`, ou nome.
 */
export function resolveMessagingTemplateByCode(
  templates: MessagingTemplate[],
  templateCode: string | null | undefined,
): MessagingTemplate | null {
  const code = String(templateCode ?? "").trim();
  if (!code || templates.length === 0) return null;

  const byExactId = templates.find((t) => t.id === code);
  if (byExactId) return byExactId;

  const byIdContains = templates.find(
    (t) => t.id.endsWith(`_${code}`) || t.id.endsWith(code) || code.endsWith(t.id),
  );
  if (byIdContains) return byIdContains;

  const suffix = code.includes("_") ? code.slice(code.lastIndexOf("_") + 1) : code;
  if (!suffix) return null;

  return (
    templates.find(
      (t) =>
        t.id === suffix ||
        t.id.endsWith(`_${suffix}`) ||
        t.name.trim().toLowerCase() === suffix.toLowerCase(),
    ) ?? null
  );
}
